import React from 'react';
import { Col, Row, Tabs } from 'antd';
import PeriodList from 'pages/periods/periods-list';
import PersonalTrainingListFunctional from './components/personal-training-list-functional';
import { Dumbbell, CalendarClock } from 'lucide-react';
import './style.scss';
import { useI18n } from 'hooks/useI18n';

const PersonalTrainingList = () => {
	const { t } = useI18n();
	const tabItems = [
		{
			key: 'pt',
			label: (
				<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
					<Dumbbell size={16} />
					{t('navigation.personal_training')}
				</span>
			),
			children: <PersonalTrainingListFunctional />,
		},
		{
			key: 'months',
			label: (
				<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
					<CalendarClock size={16} />
					{t('periods.create_period')}
				</span>
			),
			children: <PeriodList />,
		},
	];

	return (
		<Row className="personal-training-tab-container">
			<Col xl={24} className="container">
				<Tabs defaultActiveKey="pt" destroyInactiveTabPane items={tabItems} />
			</Col>
		</Row>
	);
};

export default PersonalTrainingList;
